import type { Response } from '@/types/http'
import type { ActivityDetailRaw, GrabResultRaw } from '@/types/redPacketRain'
import { http } from '@/utils/http'

export function getActivityRainDetail() {
  return http<Response<ActivityDetailRaw | ActivityDetailRaw[] | null>>(
    '/app-api/activity/red-packet-rain/detail',
    {
      method: 'POST'
    }
  )
}

export function canParticipate(activityId: string | number) {
  return http<Response<boolean>>('/app-api/activity/red-packet-rain/can-participate', {
    method: 'POST',
    body: { id: activityId }
  })
}

export function grabRedPacket(configId: string | number, sessionId: string, num: number) {
  return http<Response<GrabResultRaw>>('/app-api/activity/red-packet-rain/grab', {
    method: 'POST',
    body: {
      configId,
      sessionId,
      num
    }
  })
}
